import styled from '@emotion/styled';
const Ul = styled.div `
  background: transparent;
  padding-inline-end: 0 !important;
  padding-inline-start: 0 !important;
  display: flex;
  flex-direction: column;
  gap: 1px;

  strong {
    margin-bottom: 0.5em;
  }

  margin: 14px 0;

  button {
    border-radius: var(--radius-5);
  }

  div:not(:last-of-type) {
    button {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  div:not(:first-of-type) {
    button {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  &:empty {
    display: none;
  }
`;
/**
 *
 */
export const Group = ({ children, ...props }) => <Ul {...props}>{children}</Ul>;
